import React from 'react';
import Select from 'react-select';
import styled from 'styled-components';
//import { SubtitleThree } from '../../../styles/theme/typography';

const Wrapper = styled.div`
  max-width: 400px;
  margin-left: auto;
  display: flex;
  justify-content: flex-end;

  align-items: center;

  .react-select__control--is-focused {
    border-color: #2a5caf !important;
  }

  .react-select__menu {
    z-index: 7;
  }

  .sort-by {
    font-size: 12px;
    color: ${({ theme }) => theme.colors.charcoal};
    margin-right: 8px;

    @media only screen and (min-width: 992px) {
      font-size: 15px;
      margin-right: 12px;
    }
  }

  .react-select__single-value {
    color: ${({ theme }) => theme.colors.charcoal};
  }

  .react-select__option {
    font-size: 16px;
    color: ${({ theme }) => theme.colors.charcoal};
  }

  .react-select__indicator-separator {
    display: none;
  }

  .react-select__option--is-selected {
    background-color: ${({ theme }) => theme.colors.limoncello};
    color: ${({ theme }) => theme.old ? 'white' : theme.colors.charcoal};
  }

  @media (max-width: 992px) {
    max-width: 100%;
  }
`;

const options = [
  { value: null, label: 'Featured' },
  { value: 'price_asc', label: 'Price - Low to High' },
  { value: 'price_desc', label: 'Price - High to Low' },
  { value: 'newest', label: 'Newest' }
];

function SortBy({ selected, setSelected }) {
  const handleChange = value => {
    setSelected(value);
  };

  return (
    <Wrapper>
      <span className="sort-by">Sort By</span>
      <Select
        styles={{
          // Fixes the overlapping problem of the component
          menu: provided => ({ ...provided, zIndex: 9999 }),
          control: provided => ({
            ...provided,
            fontSize: '12px',
            width: '124px',
            height: '26px',
            minHeight: '26px',
            borderRadius: 0,
            "@media only screen and (min-width: 992px)": {
              ...provided["@media only screen and (min-width: 992px)"],
              height: "35px",
              minHeight: "35px",
              width: "188px",
              fontSize: "15px"
            },
          }),
          valueContainer: provided => ({
            ...provided,
            height: '26px',
            "@media only screen and (min-width: 992px)": {
              ...provided["@media only screen and (min-width: 992px)"],
              height: "35px",
            },
          }),
          input: (provided) => ({
            ...provided,
            margin: '0px',
          }),
          indicatorSeparator: () => ({
            display: 'none',
          }),
          indicatorsContainer: (provided, state) => ({
            ...provided,
            height: '26px',
            "@media only screen and (min-width: 992px)": {
              ...provided["@media only screen and (min-width: 992px)"],
              height: "35px",
            },
          }),
        }}
        value={selected}
        onChange={handleChange}
        options={options}
        isSearchable={false}
        classNamePrefix="react-select"
      />
    </Wrapper>
  );
}

export default SortBy;
